import React, { Fragment } from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import { downloadExcelByTable } from 'function/file';

// style
const linkStyle = {
  color: 'var(--falcon-danger)',
  textDecoration: 'underline',
  cursor: 'pointer'
};

/*
 * 보고서 > 한계기준이탈현황(분기)
 */

const Quater = ({ year, data, totalSumData, onDetailModal }) => {
  /* variable */
  const title = '한계기준이탈 분기별 현황';
  const yyyy = Number(moment(year).format('YYYY'));

  /* event */

  /* 엑셀다운로드 */
  const onExcelDown = () => {
    const excelTilte = `${title}_${yyyy}.xlsx`;
    const excelTable = document.getElementById('limitStdQuater');
    downloadExcelByTable(excelTable, excelTilte);
  };

  const onDetail = (itemCd, itemNm, detailType, cycleNum, count) => {
    if (count === 0 || count === undefined) return;

    const detailData = {
      itemCd: itemCd,
      itemNm: itemNm,
      detailType: detailType,
      cycleNum: cycleNum
    };

    onDetailModal(detailData);
  };

  return (
    <>
      <Row className="align-items-center g-2 mb-2">
        <Col className="d-flex align-items-center">
          <h6 className="fs-0 mb-0">{title}</h6>
        </Col>
        <Col xs={'auto'}>
          <Button
            size="sm"
            variant="secondary"
            onClick={onExcelDown}
            disabled={data?.length === 0}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>

      <Table
        responsive
        bordered
        className="fs--1 text-center mb-3"
        id="limitStdQuater"
      >
        <thead className="bg-200 text-700 align-middle border-300">
          <tr>
            <th className="text-nowrap" rowSpan={2}>
              원료
            </th>
            <th className="text-nowrap" rowSpan={2}>
              구분
            </th>
            <th className="text-nowrap" rowSpan={2}>
              건수
            </th>
            <th className="text-nowrap">연 총계</th>
            <th className="text-nowrap">1분기</th>
            <th className="text-nowrap">2분기</th>
            <th className="text-nowrap">3분기</th>
            <th className="text-nowrap">4분기</th>
          </tr>
          <tr>
            {totalSumData?.map(({ totalSum, totalExcdSum }, index) => (
              <Fragment key={index}>
                <td className="bg-soft-primary">
                  {totalSum || '-'} /{' '}
                  <span className="text-danger">{totalExcdSum || '-'}</span>
                </td>
              </Fragment>
            ))}
          </tr>
        </thead>
        <tbody className="align-middle">
          {data?.map(
            (
              {
                itemNm,
                itemCd,
                insideTotalCnt,
                insideExcdCnt,
                outsideTotalCnt,
                outsideExcdCnt
              },
              index
            ) => (
              <Fragment key={index}>
                {/* 내부 */}
                <tr>
                  <td className="bg-200 border-bottom border-300" rowSpan={4}>
                    {itemNm}
                  </td>
                  <td className="bg-200 border-bottom border-300" rowSpan={2}>
                    내부
                  </td>
                  {/* 내부 - 전체건수 */}
                  <td className="bg-200 border-bottom border-300">전체건수</td>
                  {Object.values(insideTotalCnt)?.map((value, index) => (
                    <td
                      className={
                        index === 0
                          ? 'bg-soft-primary border-bottom border-300'
                          : null
                      }
                      key={index}
                    >
                      {value || '-'}
                    </td>
                  ))}
                </tr>
                <tr>
                  {/* 내부 - 이탈현황 */}
                  <td className="bg-200 border-bottom border-300">이탈현황</td>
                  {Object.values(insideExcdCnt)?.map((value, index) => (
                    <Fragment key={index}>
                      {index === 0 && (
                        <td className="bg-soft-primary border-bottom border-300 text-danger">
                          {value || '-'}
                        </td>
                      )}
                      {index > 0 && (
                        <td
                          onClick={() =>
                            onDetail(itemCd, itemNm, 'inex', index, value)
                          }
                          style={value > 0 ? linkStyle : null}
                        >
                          {value || '-'}
                        </td>
                      )}
                    </Fragment>
                  ))}
                </tr>
                {/* 외부 */}
                <tr>
                  <td className="bg-200 border-bottom border-300" rowSpan={2}>
                    외부
                  </td>
                  {/* 외부 - 전체건수 */}
                  <td className="bg-200 border-bottom border-300">전체건수</td>
                  {Object.values(outsideTotalCnt)?.map((value, index) => (
                    <td
                      className={
                        index === 0
                          ? 'bg-soft-primary border-bottom border-300'
                          : null
                      }
                      key={index}
                    >
                      {value || '-'}
                    </td>
                  ))}
                </tr>
                <tr>
                  {/* 외부 - 이탈현황 */}
                  <td className="bg-200 border-bottom border-300">이탈현황</td>
                  {Object.values(outsideExcdCnt)?.map((value, index) => (
                    <Fragment key={index}>
                      {index === 0 && (
                        <td className="bg-soft-primary border-bottom border-300 text-danger">
                          {value || '-'}
                        </td>
                      )}
                      {index > 0 && (
                        <td
                          onClick={() =>
                            onDetail(itemCd, itemNm, 'ouex', index, value)
                          }
                          style={value > 0 ? linkStyle : null}
                        >
                          {value || '-'}
                        </td>
                      )}
                    </Fragment>
                  ))}
                </tr>
              </Fragment>
            )
          )}
        </tbody>
      </Table>
    </>
  );
};

export default Quater;
